import { PUBLIC_DASHBOARD_URL } from '$env/static/public';

export interface FooterLink {
	href: string;
	label: string;
	external?: boolean;
}

export interface FooterSection {
	title: string;
	links: FooterLink[];
}

export const DASHBOARD_URL = PUBLIC_DASHBOARD_URL || 'https://app.talentprofile.net';

export const talentSections: FooterSection[] = [
	{
		title: 'For Talents',
		links: [
			{ href: '/', label: 'Homepage' },
			{ href: '/drop-cv', label: 'Drop Resume' },
			{ href: '/how-it-works', label: 'How It Works' },
			{ href: '/jobs', label: 'Browse Jobs' },
			{ href: '/companies', label: 'Companies' },
		]
	},
	{
		title: 'Jobs by Category',
		links: [
			{ href: '/jobs/backend', label: 'Backend' },
			{ href: '/jobs/frontend', label: 'Frontend' },
			{ href: '/jobs/fullstack', label: 'Full-Stack' },
			{ href: '/jobs/mobile', label: 'Mobile' },
			{ href: '/jobs/data', label: 'Data & ML' },
			{ href: '/jobs/infrastructure', label: 'DevOps & SRE' },
			{ href: '/jobs/qa_testing', label: 'QA & Testing' },
		]
	}
];

export const companySections: FooterSection[] = [
	{
		title: 'For Employers',
		links: [
			{ href: '/hire', label: 'Post a Job' },
			{ href: '/drop-jd', label: 'Drop Job Description' },
			{ href: '/talent-profile-vs-traditional-ats', label: 'vs Traditional ATS' },
			{ href: '/pricing', label: 'Pricing' },
		]
	},
	{
		title: 'Hire by Role',
		links: [
			{ href: '/hire-backend-developers', label: 'Backend Developers' },
			{ href: '/hire-frontend-developers', label: 'Frontend Developers' },
			{ href: '/hire-full-stack-developers', label: 'Full-Stack Developers' },
			{ href: '/hire-data-engineers', label: 'Data Engineers' },
			{ href: '/hire-devops-engineers', label: 'DevOps Engineers' },
			{ href: '/hire-mobile-developers', label: 'Mobile Developers' },
			{ href: '/hire-qa-tester', label: 'QA Tester' },
		]
	}
];

export const generalSections: FooterSection[] = [
	{
		title: 'Company',
		links: [
			{ href: '/faq', label: 'FAQ' },
			{ href: '/blog', label: 'Tech Insights' },
			{ href: '/contact', label: 'Contact' },
			{ href: '/privacy', label: 'Privacy Policy' },
			{ href: '/terms', label: 'Terms of Service' },
		]
	}
];

export const footerSections = [...talentSections, ...companySections, ...generalSections];

export function isEmployerPage(pathname: string): boolean {
	const employerUrls = companySections.flatMap(section => section.links.map(link => link.href));
	return employerUrls.some(url => pathname === url || pathname.startsWith(url));
}